import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ConvertSuccessPanelProps {
  itemsCount: number;
  onClose: () => void;
  onNavigateToVerification: () => void;
}

const ConvertSuccessPanel: React.FC<ConvertSuccessPanelProps> = ({
  itemsCount,
  onClose,
  onNavigateToVerification,
}) => {
  const { t } = useTranslation();

  return (
    <div className="py-8 text-center">
      {/* preflight makes svg a block, so an inline icon needs centring itself. */}
      <CircleCheck className="mx-auto mb-4 size-16 text-success" strokeWidth={1.5} />
      <h3 className="revy-cjk revy-figure mb-2 text-lg font-medium leading-[1.5]">
        {t('drbfm.convert.successTitle', { count: itemsCount })}
      </h3>
      <p className="revy-cjk mb-6 text-sm leading-[1.6] text-muted-foreground">
        {t('drbfm.convert.successDescription')}
      </p>
      <div className="flex justify-center gap-4">
        <Button variant="outline" onClick={onClose}>
          <span className="revy-cjk">{t('common.close')}</span>
        </Button>
        <Button onClick={onNavigateToVerification}>
          <span className="revy-cjk">{t('drbfm.convert.viewVerificationItems')}</span>
        </Button>
      </div>
    </div>
  );
};

export default ConvertSuccessPanel;
